module.exports = __webpack_public_path__ + "static/images/presell.0d9da8c.png";